// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pagination-container[data-v-a2a908c8]{background:#fff;padding:20px 16px;overflow:hidden}.pagination-container .el-pagination[data-v-a2a908c8]{float:right}.pagination-container.hidden[data-v-a2a908c8]{display:none}", ""]);
// Exports
module.exports = exports;
